export default __webpack_public_path__ + "4eabd31fb5226ebfb4d165301de1aaf5.jpg";